import React, { useMemo, useEffect } from "react";
import { useTable, useSortBy, useFilters } from "react-table";

import TextFilter from "./TextFilter";

/*
 * https://www.akashmittal.com/react-table-learn-filter-sort-pagination-in-10-minutes/
 *  Primarily used the above tutorial to get through this.
 */

export default function HolidayDataTable({ columns, data, showFilter }) {
  const dateBetweenFilterFn = (rows, id, filterValues) => {
    const sd = new Date(filterValues[0]);
    const ed = new Date(filterValues[1]);

    return rows.filter(r => {
      const time = new Date(r.values[id]);
      if (filterValues.length === 0) {
        return rows;
      }

      return (time >= sd && time <= ed);
    });
  };

  dateBetweenFilterFn.autoRemove = val => !val;

  const defaultColumn = useMemo(
    () => ({
      Filter: TextFilter
    }),
    []
  );

  const filterTypes = useMemo(
    () => ({
      text: (rows, id, filterValue) => rows.filter(row => {
        const rowValue = row.values[id];

        return rowValue !== undefined ?
          String(rowValue)
            .toLowerCase()
            .startsWith(String(filterValue).toLowerCase()) :
          true;
      }),
      dateBetween: dateBetweenFilterFn,
      number: (rows, id, filterValue) => rows.filter(row => {
        const rowValue = row.values[id];

        return rowValue !== undefined ?
          String((rowValue * 100.00).toFixed(2))
            .toLowerCase()
            .startsWith(String(filterValue).toLowerCase()) :
          true;
      })
    }),
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    setAllFilters
  } = useTable({
    columns,
    data,
    disableSortRemove: true,
    defaultColumn,
    filterTypes
  }, useFilters, useSortBy);

  useEffect(() => {
    if (!showFilter) {
      setAllFilters([]);
    }
  }, [showFilter]);

  return (
    <table {...getTableProps()}>
      <thead>
        {headerGroups.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map(column => (
              <th {...column.getHeaderProps()}>
                <div {...column.getSortByToggleProps()}>
                  {column.render("Header")}
                </div>
                <div>{column.canFilter && showFilter ? column.render("Filter") : null}</div>
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row, i) => {
          prepareRow(row);

          return (
            <tr {...row.getRowProps()}>
              {row.cells.map(cell => <td style={{ minWidth: `${cell.column.width ? cell.column.width : 170}px` }} {...cell.getCellProps()}>{cell.render("Cell")}</td>)}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
